/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountAllowance
 */
export interface AccountAllowance {
    /**
     * 
     * @type {string}
     * @memberof AccountAllowance
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof AccountAllowance
     */
    amount: string;
}

export function AccountAllowanceFromJSON(json: any): AccountAllowance {
    return AccountAllowanceFromJSONTyped(json, false);
}

export function AccountAllowanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountAllowance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'amount': json['amount'],
    };
}

export function AccountAllowanceToJSON(value?: AccountAllowance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'amount': value.amount,
    };
}


